
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import axios from 'axios'
import CommonUtils from '@/common-utils'
import Constants from '@/constants'
import { 
  TestPaperLibraryOVO, 
  CorrectAnswerOVO, 
  TestPaperIVO, 
  TestPaperOVO,
  MstKeypointVO } from '@/views/biz/omr/vo/Omr.vo'
import { SettingsOmrVO } from '@/components/vo/Settings.vo'
import { WrongAnswerNoteOVO } from '@/views/biz/note/vo/WrongAnswerNote.vo'
import { PieChartVO } from '@/components/vo/Chart.vo'
import ExplanationDialog from '@/components/ExplanationDialog.vue'
import ExplanationFormDialog from '@/components/ExplanationFormDialog.vue'
import MemoFormDialog from '@/components/MemoFormDialog.vue'
import SettingsDialog from '@/components/SettingsDialog.vue'
import ChartAnalysisDialog from '@/components/ChartAnalysisDialog.vue'
import QuestionAnalysisDialog from '@/components/QuestionAnalysisDialog.vue'
import TestPaperDialog from '@/components/TestPaperDialog.vue'
import PieChart from '@/components/PieChart.vue'
import LineChart from '@/components/LineChart.vue'
import { mapState } from 'vuex'

@Component({
  components: {PieChart, LineChart, ExplanationFormDialog, ExplanationDialog, SettingsDialog, ChartAnalysisDialog, QuestionAnalysisDialog, MemoFormDialog, TestPaperDialog }
})
export default class WrongAnswerNoteDetail extends Vue {
  @Prop() emNo!: string;
  drawNav = false;
  mini = true;
  questionAnalysisDialog = false;
  currentExplanation = {} as CorrectAnswerOVO;
  msgDialog = false;
  currentHelpMsg = {};


  wrongAnswerNotes: Array<WrongAnswerNoteOVO> = [] as Array<WrongAnswerNoteOVO>;
  correctAnswers: Array<CorrectAnswerOVO> = [] as Array<CorrectAnswerOVO>;

  // 푸터
  questionStartNumber = 0;
  answerNumbering = {
    exam3 : [1, 16, 31], // 대체 시험 문제 시작 넘버링
    exam4 : [1, 36],     // 기말 시험 문제 시작 넘버링
    exam5 : [1],         // 하계 시험 문제 시작 넘버링
    exam6 : [1]          // 동계 시험 문제 시작 넘버링
  };

  // 환경설정
  settings: SettingsOmrVO = {} as SettingsOmrVO;

  // 차트
  pieChartVO: PieChartVO = {} as PieChartVO;

  // 문제 분석
  questionNumber = null;

  // 기출문제 자료 개수
  testPaperCount = 0;

  isGroupQuestionMsg = {
    title: '오답노트 문항노출 도움말',
    msg: '내가 푼 문제의 정답률이 오답노트에 노출될지 여부를 결정해요. 보고싶은 구간만 선택하면 보기 더 편해요.'
  }

  hideModeMsg = {
    title: '가리기 모드 도움말',
    msg: '비노출 문항을 완전히 가리거나 또는 흐리게 노출되도록 설정해요.'
  }

  openHelpMessages(msg): void {
    this.msgDialog = !this.msgDialog;
    this.currentHelpMsg = msg;
  }


  // 유형별 채점 결과(파이차트)
  get getPieChartData() {
    let unknownCount = 0;
    let ambiguousCount = 0;
    let knownCount = 0;

    this.wrongAnswerNotes.forEach((v, i) => {
      if(CommonUtils.getQuestionType(v).type == 'unknown') {
        unknownCount += 1;
      }

      if(CommonUtils.getQuestionType(v).type == 'ambiguous') {
        ambiguousCount += 1;
      }

      if(CommonUtils.getQuestionType(v).type == 'known') {
        knownCount += 1;
      }
    })

    this.pieChartVO.colors = ['rgb(0 178 210)', '#41B883', '#E46651'];
    this.pieChartVO.labels = ['아는문제', '애매모호한문제', '모르는문제'];
    this.pieChartVO.data = [knownCount, ambiguousCount, unknownCount];

    return this.pieChartVO;
  }



  // 풀이/메모 조회
  viewExplanation(item: CorrectAnswerOVO): void {
    this.currentExplanation = item;
    this.$store.dispatch(`explanation/openModal`, {name: 'explanation'});
  }

  getWindowSize(){
    switch (this.$vuetify.breakpoint.name) {
      case 'xs': return 220
      case 'sm': return 400
      case 'md': return 500
      case 'lg': return 600
      case 'xl': return 800
    }
  }

  // 다시 풀기
  async retryTest() {
    const res =  await this.$confirm(`기출문제 [${this.wrongAnswerNotes[0].smNm}] 답안지로 이동할까요?`, CommonUtils.baseConfirmOption);
    
    if(res) {
      this.$router.push({name: 'OmrLearn', params: {emNo: this.emNo}});
    }
  }

  // 문항 수 변경
  refreshAnswerNumbering() {
    this.questionStartNumber = (this.questionStartNumber + 1)
      % (this.answerNumbering['exam' + this.wrongAnswerNotes[0].emExam].length);
  }

  @Watch('$store.state.explanation.opened')
  @Watch('$store.state.explanationForm.opened')
  @Watch('$store.state.memoForm.opened')
  changeExplanationDialog(e) {
    console.log(e)
    // 정답안 조회
    axios.get(`omr/correct-answers/${this.emNo}`)
    .then(r => {
      this.correctAnswers = r.data;
    })
  }

  // 정답률 구간에 해당되지 않는 문제인지 여부
  getIsHideQuestions(index: number) {
    if(!this.settings.isGroupQuestion) {
      return false;
    }

    const item = this.wrongAnswerNotes[index];

    // 모르는문제 가림(구간에 해당되면)
    if(!this.settings.isShowUnknownQuestion && CommonUtils.getQuestionType(item).type == 'unknown') {
      return true;
    }

    //애매모호한문제 가림(구간에 해당되면)
    if(!this.settings.isShowAmbiguousQuestion && CommonUtils.getQuestionType(item).type == 'ambiguous') {
      return true;
    }

    // 확실히 아는문제 가림(구간에 해당되면)
    if(!this.settings.isShowKnownQuestion && CommonUtils.getQuestionType(item).type == 'known') {
       return true;
    }
  }

  // 전체 평균
  getTotalAverage() {
    const totalCount = this.wrongAnswerNotes[0].userAnsrCnt * this.wrongAnswerNotes.length;
    let correctAnswerCount = 0 as number;
    for(const i in this.wrongAnswerNotes) {
      correctAnswerCount += parseInt(this.wrongAnswerNotes[i].crtAnsrCnt.toString());
    }
    return ((correctAnswerCount/totalCount) * 100).toFixed(2);
  }

  // 핵심포인트 문제 등록/삭제
  setKeypoint(qstNo: number) {
    const param: MstKeypointVO = {} as MstKeypointVO;
    param.emNo = this.emNo;
    param.qstNo = qstNo;

    axios.post('/omr/keypoint', param)
    .then(r=>{
      this.correctAnswers[qstNo-1].keypoint = r.data;
      if(r.data) {
        this.$toast('핵심 문제로 등록됐어요');
        return;
      }
      this.$toast('해제 됐어요');
    })
  }

  @Watch('settings', {deep: true})
  changeSettings(ev: SettingsOmrVO): void {
    // 자동채점과 채점완료문항가리기는 셋트로 움직임
    if(ev.isAutoGrade == false) {
      this.settings.isHideGradeSuccess = false;
    }
    CommonUtils.putLocalStorageObject(Constants.SETTINGS_OMR, ev);
  }

  created(): void {
    // 오답노트 목록 조회
    axios.get(`/wrong-answer-note/${this.emNo}`)
    .then(r => {
      this.wrongAnswerNotes = r.data.wrongAnswers;
      this.correctAnswers = r.data.correctAnswers;
    })

    /*
    * 이거 개수조회로 변경해야함...
    */
    // 기출문제 시스템 업로드 이미지 개수 조회
    // 저작권때문에 막아야함..
    // 이거 나중에 다 바꿔야됨..(한쪽으로 몰아..)
    if(Constants.IS_USED_TEST_PAPER_LIBRARY) {
      axios.get(`omr/test-papers/library`, {params: {emNo: this.emNo}})
      .then(r => {
        this.testPaperCount += r.data.length
      })
    }

    /*
    * 이거 개수조회로 변경해야함...
    */
    // 개인이 업로드한 기출문제 시험지 조회
    // 이거 나중에 다 바꿔야됨..(한쪽으로 몰아..)
    axios.get(`omr/test-papers`, {params: {emNo: this.emNo}})
    .then(r => {
      this.testPaperCount += r.data.length
    })

    this.settings = CommonUtils.getLocalStorageObject(Constants.SETTINGS_OMR);

    this.getWindowSize() < 800 ? this.drawNav = false : this.drawNav = true;
  }
}
